import { render, staticRenderFns } from "./JobReviewCreated.vue?vue&type=template&id=37830a6d&scoped=true&"
import script from "./JobReviewCreated.vue?vue&type=script&lang=js&"
export * from "./JobReviewCreated.vue?vue&type=script&lang=js&"
import style0 from "./JobReviewCreated.vue?vue&type=style&index=0&id=37830a6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37830a6d",
  null
  
)

export default component.exports